<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 mx-1 my-2">
        <div class="col-span-8 mx-auto px-4 border border-gray rounded-md">
          <div class="grid grid-cols-12 gap-4" v-for="(message, idx) in messages" :key="idx">
            <div class="col-span-12">
              <div class="grid grid-cols-12 gap-4" v-if="message.user.accountType === 'INDIVIDUAL'">
                <div class="col-span-8 py-2 rounded-md bg-gray-10 my-2 text-gray">
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <span class="text-sm font-bold text-capitalize">{{message.name}}</span>
                      <span class="bg-green rounded text-white text-capitalize px-1 ml-1"
                            style="font-size: 8px; padding-bottom: 2px; padding-top: 2px;" v-if="message.user">
                      {{message.user.accountType.toLowerCase()}}
                   </span><br/>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <span class="text-sm">{{message.description}}</span>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <span style="font-size:9px" class="text-blue italic">{{dateFormat(message.dateTime)}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-span-4"></div>
              </div>
              <div class="grid grid-cols-12 gap-4" v-else>
                <div class="col-span-4"></div>
                <div class="col-span-8 py-2 rounded-md bg-green-pale my-2 text-gray">
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <span class="text-sm font-bold">{{message.name}}</span>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <span class="text-sm">{{message.description}}</span>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                      <span style="font-size:9px" class="text-blue italic">{{dateFormat(message.dateTime)}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="grid grid-cols-12 gap-4" v-if="messages.length == 0">
            <div class="col-span-11 mx-auto rounded-md bg-gray-10 my-2 text-gray">
              <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                  <span class="text-xs font-bold">No messages yet</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { usePractitionersRegistryStore } from "@/stores/practitioners-registry";
import { dateFormat } from "@/commons/composables/utilities";

const store = usePractitionersRegistryStore();
const messages = ref<any[]>([]);

onMounted(() => {
  const id = store.practitioner_task?.processId;
  store.fetchPractitionerTaskMessages(id);
});

watch(() => store.practitioner_messages, (data) => {
  if (data) {
    for (let i = 0; i < data.length; i++) {
      let message = data[i];
      if (message.description !== "" && message.description != null) {
        messages.value.push(message);
      }
    }
  }
})
</script>
